import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import PaymentMain from "./PaymentMain";

const Payments: React.FC = () => {
  return (
    <div className="orders">
      <Sidebar activeTab="Payments" />
      <PaymentMain />
    </div>
  );
};

export default Payments;
